import { useCallback } from 'react';
import { toast } from 'sonner';
import { IOperationResultNoValue } from '../../extViewmodels';
import { useEventLogging } from '../../models/Logging';

export const useResponseHandler = (action: string, errorMessage = '') => {
	const { logApiError } = useEventLogging();

	const errorHandler = useCallback((err: IOperationResultNoValue) => {
		logApiError(`${action}-Error`, err);

		toast.error(err.systemMessage || errorMessage);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return [errorHandler] as const;
};
